// services/caseService.js
import axios from "axios"

class CaseService {
  api

  constructor() {
    this.api = axios.create({
      baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000/api/v1",
    })
    this.api.interceptors.request.use((config) => {
      const token = localStorage.getItem("Token")
      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Token ${token}`,
          withCredentials: false,
          "Content-Type": "application/json; charset=UTF-8",
        }
      }
      return config
    })
  }

  // (Existing) Generic list
  async getCaseList(page = 1, limit = 10) {
    const response = await this.api.get("/case/", { params: { page, limit } })
    return response.data
  }

  async getCasesByLawyer({ lawyerId, page = 1, limit = 10, filters = {} }) {
    if (!lawyerId) throw new Error("lawyerId is required")
    const params = { page, lawyer: lawyerId, limit, ...filters }
    const response = await this.api.get("/cases/crm-filter-by-lawyer/", { params })
    return response.data
  }
}

export default new CaseService()
